var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  .skeleton-box{\n    height:5px;\n  }\n"], ["\n  overflow: hidden;\n  .skeleton-box{\n    height:5px;\n  }\n"])));
var ProgressBarSkeleton = function ProgressBarSkeleton() {
    return (_jsx(Wrapper, { children: _jsx("span", { className: "skeleton-box w-100" }) }));
};
export default ProgressBarSkeleton;
var templateObject_1;
